module.exports = __webpack_public_path__ + "r-v3/img/ml_30_00_over.f09ed876.jpg";